import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getItemAmountError } from '@/returns/helpers/helpers'

import ConceptAmountInput from '../ConceptAmountInput/ConceptAmountInput'
import * as Styles from './styles'

const ConceptItemRow = ({ item, currency, isNegative, disabled, onChangeAmount }) => {
  const theme = useTheme()

  const handleChangeAmount = amount => {
    onChangeAmount(item.id, amount)
  }

  return (
    <Styles.Container>
      <Styles.InfoContainer>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {item.name}
        </Text>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {item.variant}
        </Text>
      </Styles.InfoContainer>
      <Styles.InputContainer>
        <ConceptAmountInput
          label={item.name}
          value={item.amount}
          currency={currency}
          isNegative={isNegative}
          maxAmount={item.max_amount}
          error={getItemAmountError(item)}
          disabled={disabled}
          onChange={handleChangeAmount}
        />
      </Styles.InputContainer>
    </Styles.Container>
  )
}

export default ConceptItemRow
